"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
const PLACEHOLDER_ROWS = 3;
export function CartSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div role="status" aria-label="Loading cart" data-testid="cart-skeleton" className="flex flex-1 flex-col overflow-hidden">{Array.from({
        length: PLACEHOLDER_ROWS
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <div key={index} className="flex gap-5 border-b-2 border-gray-100 px-5 py-5"><Skeleton className="size-[100px] shrink-0 bg-neutral-200" /><div className="flex flex-1 flex-col gap-3"><Skeleton className="h-5 w-3/4 bg-neutral-200" /><Skeleton className="h-4 w-1/3 bg-neutral-200" /><Skeleton className="h-10 w-full bg-neutral-200" /></div></div>;
}